var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book_box",on:{"mousemove":function($event){return _vm.handleMove($event)}}},[_c('div',{staticClass:"doodles",style:(`transform: 
    translate3d(${_vm.translationL * 2}px,${_vm.translationR * 2}px, 0px);`)}),_c('div',{staticClass:"book"},_vm._l((_vm.images),function(img){return _c('img',{key:img,style:('transform:  translateX(-50%)  translate3d(' +
        _vm.translationL +
        'px, ' +
        _vm.translationR +
        'px, 0px);'),attrs:{"data-depth":"0.2","src":img}})}),0),_c('h1',{staticClass:"text-center text-white"},[_vm._v("未来的智慧教科书")]),_c('p',{staticClass:"text-center subtitle mt-2"},[_vm._v("智能化、立体化、互动性、自主性")])])
}
var staticRenderFns = []

export { render, staticRenderFns }